<template>
  <v-container fluid v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
    <v-row style="margin-top: -50px;" id="strategy-row">
      <v-col>
        <p class="numbered-title">Lege dein Strategiemodell fest</p>
        <p class="psmall mt-4">Finde für jede Assetklasse die zu Deinen Investmentzielen passende Anlagestrategie.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <fin-tool-row-display v-if="!archetypeSelected"
                              displayModus="iconModus"
                              name="finProfiler starten"
                              description="Um den finFinder zu starten musst du im ersten Schritt deine Ziele festlegen."
                              routeToStart="finStrategy_profiler"
                              button-align="left"/>
        <fin-tool-row-display v-for="(tool, toolIndex) in tools"
                              :key="'tool_' + toolIndex"
                              :name="tool.name"
                              :description="tool.description"
                              :button-disabled="tool.buttonDisabled"
                              :routeToStart="tool.link"
                              :class="$vuetify.breakpoint.xsOnly ? 'pa-2 mx-1' : 'pa-2 mx-2'"
                              :id="tool.id"/>
        <div v-if="!hideCommunity">
          <fin-community-ranking v-for="(comm, commIndex) in community"
                                 :key="'comm_' + commIndex"
                                 :rank-elements="comm.communityRanking"
                                 :more-link="comm.communityRankingMoreLink"
                                 show-more/>
        </div>

      </v-col>
      <v-col v-if="archetypeSelected" cols="12" md="6" order="1" order-md="2">
        <v-img :src="require('@/assets/finStrategy/finfinder.svg')"
               style="max-width: 500px"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinToolRowDisplay from '@/components/pages/finStrategy/ToolRowDisplay'
import FinCommunityRanking from '../finCommunity/ranking/CommunityRanking'
import {mapGetters} from "vuex"

export default {
  name: 'fin-strategy-finder',
  components: {
    FinCommunityRanking,
    FinToolRowDisplay
  },
  data() {
    return {
      hideCommunity: process.env.VUE_APP_HIDE_COMMUNITY === 'true'
    }
  },
  props: {
    tools: {type: Array},
    community: {type: Array},
    routeToStart: {type: String, default: '#'},
  },
  computed: {
    ...mapGetters('auth', ['profileArchetype']),
    archetypeSelected() {
      return !!this.profileArchetype
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.numbered-title {
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;

  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }
}

.start {
  float: right;
  margin: 15px;
  color: $fin-color-primary-light;
}
</style>
